<template>
    <flex-container
        justify-content="space-between"
        align-items="flex-end"
        no-wrap
    >
        <lead-list-tab-label
            :active="props.activeStatus?.equals(Status.OPEN)"
            :chip-color="'primary'"
            @click="emit('filter-status', Status.OPEN)"
        >
            Alle contacten

            <template #count>
                {{ countForStatus(Status.OPEN) }}
            </template>
        </lead-list-tab-label>

        <flex-container
            :gap="Size.xs"
            justify-content="flex-end"
            align-items="flex-end"
            no-wrap
            size="auto"
        >
            <lead-list-tab-label
                :active="props.activeStatus?.equals(Status.WON)"
                :chip-color="'green-500'"
                @click="emit('filter-status', Status.WON)"
            >
                Voltooid

                <template #count>
                    {{ countForStatus(Status.WON) }}
                </template>
            </lead-list-tab-label>
            <lead-list-tab-label
                :active="props.activeStatus?.equals(Status.LOST)"
                :chip-color="'red-500'"
                @click="emit('filter-status', Status.LOST)"
            >
                Uitgeschreven

                <template #count>
                    {{ countForStatus(Status.LOST) }}
                </template>
            </lead-list-tab-label>
        </flex-container>
    </flex-container>
</template>

<script setup lang="ts">
    import { Status, type CountLeadsCommandResponse } from '@keyvue/one-api-client';
    import LeadListTabLabel from '@/lead/lead/components/LeadListTabLabel.vue';
    import { FlexContainer, Size } from '@keyvue/one-ui';
    import { computed, inject, type Ref } from 'vue';

    const props = defineProps<{
        activeStatus: Status | null,
    }>();

    const counts = inject<Ref<CountLeadsCommandResponse>>('counts');

    function countForStatus(status: Status) {
        return computed(() => {
            return counts?.value.status?.find((findStatus) => findStatus.status === status.value)?.count ?? 0;
        });
    }

    const emit = defineEmits<{
        (e: 'filter-status', value: Status | null): void;
    }>();
</script>
